<h2 appTranslate="personal-data"></h2>

<div class="columns">
  <div class="column">
    <div><span class="firstname">{{ getValue('first_name') }}</span>&nbsp;<span class="lastname">{{ getValue('last_name') }}</span></div>
    <div><span class="gender" [appTranslate]="gender"></span>, <span class="birthdate">{{ getValue('birthdate') }}</span></div>
    <div class="avs">{{ getValue('avs') }}</div>
  </div>
  <div class="column">
    <div>{{ getValue('address') }}</div>
    <div><span>{{ getValue('zip') }}</span>&nbsp;<span>{{ getValue('city') }}</span>, <span class="country">{{ getValue('country') | uppercase }}</span></div>
    <br>
    <div>{{ getValue('email') }}</div>
    <div>{{ getValue('mobile') }}</div>
  </div>
  <div class="column">
    <div class="lucrative_activity">
      <span appTranslate="lucrative_activity_short"></span>&nbsp;<span [appTranslate]="lucrative_activity"></span>
    </div>
    <div class="employment" *ngIf="lucrative_activity">
      <span appTranslate="employment_terminated_short"></span>&nbsp;<span [appTranslate]="employment_terminated"></span>
    </div>
    <div class="pension_fund">
      <span>{{ pension_fund }}</span>
    </div>
    <div class="group civil_status" [appTranslate]="civil_status"></div>
  </div>
</div>

